module.exports = __webpack_public_path__ + "2f0b7bdd21ca198e4d01cfc68027174e.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-main-1024.webp
// module id = 318
// module chunks = 0